module.exports = __webpack_public_path__ + "static/img/tuijian_bg.1bfe45a9.png";